define('services/ImportExportService',['app', 'modules/module', 'services/EntityCrudService'], function (app, module) {
	'use strict';
	return module.factory('ImportExportService', ['$injector', ImportExportService]);
});

function ImportExportService($injector) {
	crudInstance = $injector.instantiate(CrudService);
	crudInstance.setType('ImportExport');

	angular.extend(this, crudInstance);

	this.importRecipientsCSV = function (recipientsCSV) {
		return this.getModel().importRecipientsCSV({
			recipientsCSV: recipientsCSV,
		}).$promise;
	};

	return this;
}
;
